<wma-icon class="size-5 text-gray-400" [name]="icon()" />
<p class="mt-2 text-sm font-semibold text-gray-900">
  <ng-content />
</p>
